import curd from '../curd'

const BASE_PATH = '/pmf/source'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/PMFPollutantSource.js